import { z } from 'zod';
/** Login request — email + plaintext password; persistence is opt-in. */
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email().max(254),
    password: z.string().min(1).max(256),
    rememberMe: z.boolean().optional().default(false),
});
/** Login response — public-safe user shape + CSRF token (double-submit). */
export const loginResponseSchema = z.object({
    user: z.object({
        id: z.string().uuid(),
        email: z.string().email(),
        displayName: z.string(),
        locale: z.string(),
        roles: z.array(z.object({
            role: z.string(),
            scopeType: z.string(),
            scopeId: z.string().uuid().nullable(),
        })),
    }),
    csrfToken: z.string(),
});
/** Password reset request — email only (always returns 204 to avoid enum'ing accounts). */
export const passwordResetRequestSchema = z.object({
    email: z.string().trim().toLowerCase().email().max(254),
});
export const passwordResetConfirmSchema = z.object({
    token: z.string().min(32).max(256),
    newPassword: z.string().min(12).max(256),
});
/** Admin-initiated password reset — send a reset link to a specific user (WMS-24). */
export const adminPasswordResetSchema = z.object({
    userId: z.string().uuid(),
});
//# sourceMappingURL=auth.js.map